/**
 * Redux Selectors for Moodle Courses
 *
 * Typed selectors for accessing Moodle courses state
 */

import Immutable from 'immutable';
import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';
import type { MoodleCourse } from '../../../types/moodle-courses';

/**
 * Get the list of Moodle courses
 */
export const selectMoodleCourses = (
  state: ImmutableRootState<unknown>,
): Immutable.List<Immutable.Map<string, unknown>> => (
  state.getIn(['moodleCourses', 'list'], Immutable.List()) as
    Immutable.List<Immutable.Map<string, unknown>>
);

/**
 * Get the list of Moodle courses as plain JavaScript array
 */
export const selectMoodleCoursesJS = (
  state: ImmutableRootState<unknown>,
): MoodleCourse[] => {
  const list = selectMoodleCourses(state);
  return list.toJS() as unknown as MoodleCourse[];
};

/**
 * Get loading state for Moodle courses
 */
export const selectMoodleCoursesLoading = (
  state: ImmutableRootState<unknown>,
): boolean => state.getIn(['moodleCourses', 'isLoading'], false) as boolean;

/**
 * Get error state for Moodle courses
 */
export const selectMoodleCoursesError = (
  state: ImmutableRootState<unknown>,
): string | null => state.getIn(['moodleCourses', 'error'], null) as string | null;
